import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/v2/Tooltip';
import { ClearFilterIcon } from 'assets/v2/icons';
import { StyledClearFilterButton } from './ClearFilterButton.styles';

const ClearFilterButton = ({ onClick, disabled }) => (
  <Tooltip title="Clear Filters" placement="top" arrow>
    <span>
      <StyledClearFilterButton
        onClick={onClick}
        size="small"
        disabled={disabled}
      >
        <ClearFilterIcon />
      </StyledClearFilterButton>
    </span>
  </Tooltip>
);

ClearFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default memo(ClearFilterButton);
